import { eMessageBotPlanType } from '@core/types/chat-message.types';

export const MESSAGE_SENDER = {
    bot: 'ASSISTANT',
    user: 'USER',
} as const;

export type T_MESSAGE_SENDER = (typeof MESSAGE_SENDER)[ keyof typeof MESSAGE_SENDER ];

export enum eChatSettingTone
{
    /** Keep in sync with ADDIN_CHAT_DEFAULTS.TONE_INSTRUCTION in common/constants/chat-defaults.ts. */
    FORMAL = 'Respond in a formal tone, using proper language and etiquette.',
    INFORMAL = 'Keep it casual and relaxed in our conversation, no need for formalities.',
}

export const TONE_BASE = "You are 'R2 Copilot' - an intelligent assistant. " as const;

export const SETTING_IMG_SIZE = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    BIG: 'BIG',
} as const;

export const SETTING_IMG_RESPONSE_AS = {
    BASE_64: 'BASE_64',
    URL: 'URL',
} as const;

export const SETTING_DATA_SOURCE_TYPE = {
    COPILOT: 'COPILOT',
    REAL_TIME: 'REAL_TIME',
    BING: 'BING',
} as const;

export const MESSAGES_HISTORY_SIZE: number = 2;

/**
 * Secondary AI threads of the active document, addressed by scope (see
 * ChatBase.sendMessageToThread). The scope is appended to the document id when
 * the thread key is built, so each one is its own conversation for the same
 * document and user. The AI tab itself uses the primary thread (empty scope).
 */
export const THREAD_SCOPE = {
    /** Summaries of the group chat, rendered inline with its messages. */
    groupChat: '_groupChat',
} as const;

export const chatConstants = {
    MESSAGE_SENDER,
    TONE_BASE,
    SETTING_TONE: eChatSettingTone,
    SETTING_PLAN_TYPE: eMessageBotPlanType,
    SETTING_IMG_SIZE,
    SETTING_IMG_RESPONSE_AS,
    SETTING_DATA_SOURCE_TYPE,
} as const;
